import { cx } from "@emotion/css";
import ListItemButton from "@mui/material/ListItemButton";

function Option(props) {
	return (
		<ListItemButton
			className={cx("question-options-list--item", props.className)}
			disabled={props.disabled}
			onClick={props.onClick}
			selected={props.selected}
			data-test-id={props.testId}
		>
			{props.children}
		</ListItemButton>
	);
}

export default Option;
